import { FaqBlock as FaqBlockTypes } from "@/payload-types";

import { FaqAccordion } from "./FaqAccordion/FaqAccordion";
import { FaqList } from "./FaqList/FaqList";

const faqComponents = {
  accordion: FaqAccordion,
  list: FaqList,
};

export const RenderFaq = (props: FaqBlockTypes) => {
  const FaqToRender =
    faqComponents[props.faqStyle as keyof typeof faqComponents];
  if (!FaqToRender) return null;
  return <FaqToRender {...props} />;
};
